var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"myJoin"},_vm._l((_vm.jobListInfo),function(jobItem,index){return _c('joinMessage',{key:index,attrs:{"jobItem":jobItem}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }